import { useEffect } from 'react';
import { pushEvent } from '../utilities/analytics';
import { SEARCH_PERFORMED } from '../constants/analyticEvents';
// import { sendSearchPerformed } from '../utilities/sendSearchPerformed';
import { useCallback } from 'react';

let timeoutId;
let searchMade = false;

const useSearchPerformed = () => {
  useEffect(() => {
    // clear the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, []);

  const setAppTimeout = (delay, isClose = false) => {
    // clear any existing timeout
    if (timeoutId) { clearTimeout(timeoutId); }
    // set the new timeout
    if (!isClose || (isClose && searchMade)) {
      searchMade = true;
      timeoutId = setTimeout(() => {
        console.log('SEARCH PERFORMED:', timeoutId, delay, isClose);
        pushEvent(SEARCH_PERFORMED);
        // sendSearchPerformed(); // it's moved to load offers event
      }, delay);
    }
    // setTimeoutId(newTimeoutId);
  };

  const clearAppTimeout = useCallback(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, []);

  return [setAppTimeout, clearAppTimeout];
};

export default useSearchPerformed;
